<template>
  <div class="custom-landing">
    <div class="row flex-xl-nowrap">
      <main class="p-3 col-12" role="main">
        <slot />
      </main>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'landing',
  mounted() {
    if (!this.isAuth) {
      this.logout()
    }
  },
  computed: {
    ...mapGetters('users', ['token']),
    isAuth() {
      let _is = false
      if (this.token !== null) {
        if (this.token !== '') {
          _is = true
        }
      }
      return _is
    },
  },
  methods: {
    ...mapActions('users', ['setLogout']),
    logout() {
      this.setLogout()
      this.$inertia.post('logout')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-landing {
  width: 100%;
  height: 100vh;
  padding: 15px;
  margin: auto;
  background: none;
  background-image: url(/media/live/CorSync-Tech-Wide.PNG);
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.7;
}
</style>